import { hasOptedOut } from './onetrust';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

export function initializeGTMConsent() {
  if (typeof window === 'undefined') return;

  const optedOut = hasOptedOut();

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'consent',
    'gtm.consentMode': {
      ad_storage: optedOut ? 'denied' : 'granted',
      ad_user_data: optedOut ? 'denied' : 'granted',
      ad_personalization: optedOut ? 'denied' : 'granted',
      analytics_storage: optedOut ? 'denied' : 'granted',
      functionality_storage: 'granted',
      personalization_storage: optedOut ? 'denied' : 'granted',
      security_storage: 'granted',
      wait_for_update: 500
    }
  });
}

export function updateGTMConsent() {
  if (typeof window === 'undefined' || !window.dataLayer) return;

  const optedOut = hasOptedOut();

  window.dataLayer.push({
    event: 'consent_update',
    'gtm.consentMode': {
      ad_storage: optedOut ? 'denied' : 'granted',
      ad_user_data: optedOut ? 'denied' : 'granted',
      ad_personalization: optedOut ? 'denied' : 'granted',
      analytics_storage: optedOut ? 'denied' : 'granted',
      functionality_storage: 'granted',
      personalization_storage: optedOut ? 'denied' : 'granted',
      security_storage: 'granted'
    }
  });
}
